import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';

const buttonContainerStyle = {
    marginRight: 10,
    float: 'right',
    paddingTop: 20,
    paddingBottom: 20
}

const buttonStyle = {
    width: 100,
    marginRight: 10,
    marginLeft: 20,
};

let t;

class ChangeGatewayOwnershipDialog extends React.Component {
    constructor(props) {
        super(props);
        t = props.t;
        this.state = {
            open: props.open,
        }
    }

    handleClose = () => {
        this.props.toggleDialog();
    };

    onCancelClicked = e => {
        e.preventDefault();
        this.props.toggleDialog();
    }

    render() {
        const { fullScreen } = this.props;

        return (
            <div>
                <Dialog
                    fullScreen={fullScreen}
                    open={this.props.open}
                    onClose={this.handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">
                        {t('gateway_ownership_agreement_terms_title')}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            <b>{t('ownership')}</b>
                            <br/>
                            {t('gateway_ownership_transfer_terms_part_1_ownership')}
                            <br/>
                            <br/>
                            <b>{t('subscription')}</b>
                            <br/>
                            {t('gateway_ownership_transfer_terms_part_2_subscription')}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <div style={buttonContainerStyle}>
                            <Button
                                autoFocus
                                style={buttonStyle}
                                variant="contained"
                                color="primary"
                                onClick={e => this.onCancelClicked(e)}>
                                {t('ok')}
                            </Button >
                        </div>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }
}

ChangeGatewayOwnershipDialog.propTypes = {
    fullScreen: PropTypes.bool.isRequired,
};


export default withMobileDialog()(ChangeGatewayOwnershipDialog);


// WEBPACK FOOTER //
// ./src/Components/ChangeGatewayOwnershipTermsDialog.js